/* eslint-disable react-hooks/exhaustive-deps */
import "./admin-table.css";
import swal from "sweetalert";
import { BsTrash3Fill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  deleteComment,
  fetchAllComments,
} from "../../redux/apiCalls/commentApiCalls";
import { toast } from "react-toastify";

const CommentsTable = () => {
  const dispatch = useDispatch();
  const comments = useSelector((state) => state.comment.comments);

  useEffect(() => {
    dispatch(fetchAllComments());
  }, []);

  // Delete Comment Handler
  const deleteCommentHandler = (commentId) => {
    swal({
      title: "هل تريد حذف التعليق",
      text: "لن تستطيع استعادة التعليق ثانية",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((isOk) => {
      if (isOk) {
        dispatch(deleteComment(commentId));
        toast.success("تم حذف التعليق ");
      }
    });
  };

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <h1 className="table-title">التعليقات</h1>
        <table className="table">
          <thead>
            <tr>
              <th>م</th>
              <th>المستخدم</th>
              <th>التعليق</th>
              <th>-------</th>
            </tr>
          </thead>
          <tbody>
            {comments?.map((item, index) => (
              <tr key={item?._id}>
                <td>{index + 1}</td>
                <td>
                  <div className="table-image">
                    <img
                      src={item?.user?.profilePhoto.url}
                      alt=""
                      className="table-user-image"
                    />
                    <span className="table-username">
                      {item?.user?.username}
                    </span>
                  </div>
                </td>
                <td>
                  <b className="table-username">{item?.text}</b>
                </td>
                <td>
                  <div className="table-button-group">
                    <button onClick={() => deleteCommentHandler(item?._id)}>
                      <BsTrash3Fill />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CommentsTable;
